export const EDR_CONNECTION = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  NEVER: 'never',
} as const

export type IEdrConnection = (typeof EDR_CONNECTION)[keyof typeof EDR_CONNECTION]

export const EDR_ENDPOINT_KIND = {
  LAPTOP: 'laptop',
  SERVER: 'server',
} as const

export type IEdrEndpointKind = (typeof EDR_ENDPOINT_KIND)[keyof typeof EDR_ENDPOINT_KIND]

export const EDR_ENDPOINT_FILTER = {
  ALL: 'all',
  ...EDR_ENDPOINT_KIND,
} as const

export type IEdrEndpointFilter = (typeof EDR_ENDPOINT_FILTER)[keyof typeof EDR_ENDPOINT_FILTER]
